import axios from 'axios'

export default class Config{

    DConnect(){

        return axios.create({
            baseURL: this.BaseURL(),
            timeout: 60000,
            // headers: {
            //   'Content-Type': 'application/json',
            //   //'Authorization': JSON.stringify(auth.getAuthorization())
            // }
        })
    }

    PostOptions(itms, area){
        return {
            method: 'post',
            url: this.BaseURL() + area,
            data: itms,
            // headers: {
            //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            // }
        }
    }

    PostMulti(itms, area){
        return {
            method: 'post',
            url: this.BaseURL() + area,
            data: itms,
            // headers: {
            //     'Authorization': JSON.stringify(auth.getAuthorization())
            // }
        }
    }
    BaseURLImage = () => {
        //return 'http://demobk.insonetgh.com:700/supportapi/'//demo
       // return 'https://backend.zigloi.com/supportapi/'//live
       // return 'https://testdb.zigloi.com/supportapi/'
     //return 'http://localhost/LogicielApi/';
     //return 'http://192.168.100.8/LogicielApi/'
     return 'https://help.tarinnovation.com/api/'
     }
    Downloadlink(){
        //return 'http://144.202.59.233:8081/msms/'
        //return 'http://logiciel-test-srv.com:7000/applicationapi/public/attachments/'
       // return 'http://testdb.zigloi.com/supportapi/public/attachments/'
       // return 'http://demobk.insonetgh.com:700/supportapi/public/attachments/'//demo
      // return 'http://192.168.100.8/LogicielApi/public/attachments/'
      //return 'https://backend.zigloi.com/supportapi/public/attachments/'//live
     // return 'https://testdb.zigloi.com/supportapi/public/attachments/'
     return 'https://help.tarinnovation.com/api/public/attachments/'
    }
    BaseURL(){
       // return 'http://demobk.insonetgh.com:700/supportapi/'//demo
      // return 'https://backend.zigloi.com/supportapi/'
      //  return 'https://testdb.zigloi.com/supportapi/' //test
       // return 'http://localhost/LogicielApi/';
      //return 'http://192.168.100.8/LogicielApi/'
      return 'https://help.tarinnovation.com/api/'
    }
}
